export default __webpack_public_path__ + "static/media/soundPack1.78722133.png";